import { dequal } from 'dequal/lite';
export var isEqual = dequal;
